import Image from '@/components/image';
import { event_button_click, event_installment_option } from '@/utils/gtm';
import { useEffect, useState } from 'react';
import InstallmentText from './InstallmentText';
import MisPayModal from './MisPay-modal';

const MisPayWidget = ({ locale, amount, buttonLocation }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) {
      event_installment_option({ merchant_name: 'mis-pay' });
      event_button_click({
        button_name: 'MisPay',
        button_destination: 'open_bnpl_info',
        button_location: buttonLocation,
      });
    }
  }, [show, buttonLocation]);

  return (
    amount >= 50 &&
    amount <= 7500 && (
      <>
        <div
          onClick={() => setShow(true)}
          className='border-border flex min-h-[55px] items-center rounded-md border bg-white px-1'
        >
          <Image
            width={85}
            height={28}
            className='h-[28px] w-[85px] object-contain'
            src={`/imgs/payments/mispay-widget.svg`}
            alt='Mispay'
          />

          <InstallmentText
            {...{
              locale,
              mainPrice: Math.round(amount / 4) || '',
              onClick: () => null,
            }}
          />
        </div>
        <MisPayModal {...{ amount, locale, show, setShow }} />
      </>
    )
  );
};

export default MisPayWidget;
